import { define } from 'wicked-elements'

define('[data-component~="embed"]', {
  init () {
    this.$target = this.element.querySelector('[data-video-target]')
    this.$button = this.element.querySelector('button')
    this.embed = this.element.querySelector('template')
    this.embed = this.embed ? this.embed.content : false
    this.url = this.element.dataset.url
    this.handleClick = this.handleClick.bind(this)
  },
  connected () {
    this.$button.addEventListener('click', this.handleClick, true)
  },
  disconnected () {
    this.$button.removeEventListener('click', this.handleClick, true)
  },
  handleClick () {
    if (this.embed) {
      this.render()
    } else if (this.url) {
      window.open(this.url, '_blank')
    }
  },
  render () {
    this.$button.remove()
    this.$target.innerHTML = ''
    this.$target.classList.remove('p-5', 'md:p-10')
    this.$target.appendChild(this.embed)
  }
})